import React from 'react';
import styles from './DENTModalOverviewToothSelect.module.scss';
import { useDENTContext } from '../../Services/DENTContext';
import { Tooth } from '../../../../graphql/graphql';

interface Props {
	onToothChange?: (tooth: Tooth) => void;
}

const DENTModalOverviewToothSelect = ({ onToothChange }: Props) => {
	const { mouthData, activeTooth, setActiveTooth } = useDENTContext();

	if (!mouthData) {
		return null;
	}

	const upper = Object.entries(mouthData.upperJaw).map(([_, v]) => v);
	const lower = Object.entries(mouthData.lowerJaw)
		.reverse()
		.map(([_, v]) => v);

	const options = [...upper, ...lower];

	return (
		<div className={styles.container}>
			<ol className={styles.list}>
				{options.map(option => (
					<li
						key={option.number}
						className={`${styles.item} ${
							activeTooth?.number === option.number ? styles.selected : ''
						}`}
						onClick={() => {
							if (onToothChange) {
								onToothChange(option);
							} else {
								setActiveTooth(option);
							}
						}}>
						{option.number}
					</li>
				))}
			</ol>
		</div>
	);
};

export default DENTModalOverviewToothSelect;
